import type { ApiNgResponse, ApiOkResponse } from "./common";

export type MConditionItem = {
  id?: number;
  quake?: string | null;
  wind?: number | null;
  rain?: number | null;
  is_quake: boolean;
  is_wind: boolean;
  is_rain: boolean;
  is_rain_hour3: boolean;
  rain_hour3?: number | null;
  is_rain_hour6: boolean;
  rain_hour6?: number | null;
  is_rain_hour12: boolean;
  rain_hour12?: number | null;
  is_rain_hour24: boolean;
  rain_hour24?: number | null;
  is_rain_hour48: boolean;
  rain_hour48?: number | null;
  is_rain_hour72: boolean;
  rain_hour72?: number | null;
  is_snow_hour3: boolean;
  snow_hour3?: number | null;
  is_snow_hour6: boolean;
  snow_hour6?: number | null;
  is_snow_hour12: boolean;
  snow_hour12?: number | null;
  is_snow_hour24: boolean;
  snow_hour24?: number | null;
  is_snow_hour48: boolean;
  snow_hour48?: number | null;
  is_snow_hour72: boolean;
  snow_hour72?: number | null;
  start_at?: string | null;
  end_at?: string | null;
  heavy_rain_warning: boolean;
  heavy_snow_warning: boolean;
  storm_warning: boolean;
  blizzard_warning: boolean;
  wave_warning: boolean;
  storm_surge_warning: boolean;
  landslide_warning: boolean;
  large_tsunami_warning: boolean;
  tsunami_warning: boolean;
};

export type ConditionUpdatePayload = {
  id: number;
  is_quake: boolean;
  quake?: string | null;
  is_wind: boolean;
  wind?: number | null;
  is_rain: boolean;
  is_rain_hour3: boolean;
  is_rain_hour6: boolean;
  is_rain_hour12: boolean;
  is_rain_hour24: boolean;
  is_rain_hour48: boolean;
  is_rain_hour72: boolean;
  is_snow_hour3: boolean;
  is_snow_hour6: boolean;
  is_snow_hour12: boolean;
  is_snow_hour24: boolean;
  is_snow_hour48: boolean;
  is_snow_hour72: boolean;
  rain?: number | null;
  rain_hour3?: number | null;
  rain_hour6?: number | null;
  rain_hour12?: number | null;
  rain_hour24?: number | null;
  rain_hour48?: number | null;
  rain_hour72?: number | null;
  snow_hour3?: number | null;
  snow_hour6?: number | null;
  snow_hour12?: number | null;
  snow_hour24?: number | null;
  snow_hour48?: number | null;
  snow_hour72?: number | null;
  heavy_rain_warning: boolean;
  heavy_snow_warning: boolean;
  storm_warning: boolean;
  blizzard_warning: boolean;
  wave_warning: boolean;
  storm_surge_warning: boolean;
  landslide_warning: boolean;
  large_tsunami_warning: boolean;
  tsunami_warning: boolean;
  start_at?: string;
  end_at?: string;
};

export type UpdateConditionOptions = {
  id?: number;
};

export type WarningCheckboxKey =
  | "heavy_rain_warning"
  | "heavy_snow_warning"
  | "storm_warning"
  | "blizzard_warning"
  | "wave_warning"
  | "storm_surge_warning"
  | "landslide_warning";

export type TsunamiWarningCheckboxKey =
  | "large_tsunami_warning"
  | "tsunami_warning";

export type EarthquakeScaleOption = {
  scale: string;
  name: string;
};

export type ConditionGetOkResponse = ApiOkResponse<{
  m_condition: MConditionItem;
}>;

export type ConditionGetResponse = ConditionGetOkResponse | ApiNgResponse;

export type ConditionMutationOkResponse = ApiOkResponse<{
  m_condition: MConditionItem;
}>;

export type ConditionMutationResponse =
  | ConditionMutationOkResponse
  | ApiNgResponse;

export const buildConditionUpdatePayload = (
  condition: Partial<MConditionItem>
): ConditionUpdatePayload => ({
  id: 1,
  is_quake: condition.is_quake ?? false,
  quake: condition.quake,
  is_wind: condition.is_wind ?? false,
  wind: condition.wind,
  is_rain: condition.is_rain ?? false,
  is_rain_hour3: condition.is_rain_hour3 ?? false,
  is_rain_hour6: condition.is_rain_hour6 ?? false,
  is_rain_hour12: condition.is_rain_hour12 ?? false,
  is_rain_hour24: condition.is_rain_hour24 ?? false,
  is_rain_hour48: condition.is_rain_hour48 ?? false,
  is_rain_hour72: condition.is_rain_hour72 ?? false,
  is_snow_hour3: condition.is_snow_hour3 ?? false,
  is_snow_hour6: condition.is_snow_hour6 ?? false,
  is_snow_hour12: condition.is_snow_hour12 ?? false,
  is_snow_hour24: condition.is_snow_hour24 ?? false,
  is_snow_hour48: condition.is_snow_hour48 ?? false,
  is_snow_hour72: condition.is_snow_hour72 ?? false,
  rain: condition.rain,
  rain_hour3: condition.rain_hour3,
  rain_hour6: condition.rain_hour6,
  rain_hour12: condition.rain_hour12,
  rain_hour24: condition.rain_hour24,
  rain_hour48: condition.rain_hour48,
  rain_hour72: condition.rain_hour72,
  snow_hour3: condition.snow_hour3,
  snow_hour6: condition.snow_hour6,
  snow_hour12: condition.snow_hour12,
  snow_hour24: condition.snow_hour24,
  snow_hour48: condition.snow_hour48,
  snow_hour72: condition.snow_hour72,
  heavy_rain_warning: condition.heavy_rain_warning ?? false,
  heavy_snow_warning: condition.heavy_snow_warning ?? false,
  storm_warning: condition.storm_warning ?? false,
  blizzard_warning: condition.blizzard_warning ?? false,
  wave_warning: condition.wave_warning ?? false,
  storm_surge_warning: condition.storm_surge_warning ?? false,
  landslide_warning: condition.landslide_warning ?? false,
  large_tsunami_warning: condition.large_tsunami_warning ?? false,
  tsunami_warning: condition.tsunami_warning ?? false,
});
